module.exports = __webpack_public_path__ + "img/freemoney.5eef4cbc.png";